// extracted by mini-css-extract-plugin
export default {"header":"styles_header__LhRR6","controls":"styles_controls__fotLT","delete":"styles_delete__vtLPt"};